<app-auth-page-layout>
  <app-signup-form class="flex flex-col flex-1 w-full lg:w-1/2"/>
</app-auth-page-layout>